module.exports = __webpack_public_path__ + "img/10.1ce26978.jpg";